const RightArrrow = ({width,height}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12H4M12.968 19.66L19.54 13.088C19.6839 12.9457 19.7982 12.7763 19.8762 12.5895C19.9541 12.4028 19.9943 12.2024 19.9943 12C19.9943 11.7976 19.9541 11.5973 19.8762 11.4105C19.7982 11.2238 19.6839 11.0543 19.54 10.912L12.968 4.34003"
        stroke="#FAFAFA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default RightArrrow;
